export default "__VITE_ASSET__CQDxErTZ__"